module.exports = __webpack_public_path__ + "img/roodie-white_orange.0e02b6c7.svg";